import { IHasErrorMessage } from '@/interfaces';
import FormSearchUser from './FormSearchUser';

export default FormSearchUser;

export type TFormData = IHasErrorMessage & {
  email: string;
};
